var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscribe"},[_c('h3',{staticClass:"subscribe__title",domProps:{"innerHTML":_vm._s(_vm.$t('TotemSubscribe.subscribe'))}}),_c('div',{staticClass:"subscribe__form",attrs:{"id":"subscribeForm"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }